import { useEffect, useRef, useState } from 'react';
import { useAsync } from 'react-async';
import {
  getClassifications,
  getPricingClassifications,
} from '../api/classifications';
import { setClassificationsAction } from '../context/classifications/classificationsActions';
import { useGlobalContext } from '../context/global/GlobalContext';
import { checkFlagWithDefault } from '../common/ConfigFlags';

export const ClassificationsFetcher = () => {
  const { dispatch } = useGlobalContext();
  const [enablePricingClassifications, setEnablePricingClassifications] =
    useState<boolean | null>(null);

  // Load feature flag
  useEffect(() => {
    const checkEnablePricingClassifications = async () => {
      const storeNumber = window.sessionStorage.getItem('storeNumber');
      if (storeNumber) {
        const shouldCallCloudService = await checkFlagWithDefault(
          'EnablePricingProductClassifications',
          storeNumber,
          true
        );
        setEnablePricingClassifications(shouldCallCloudService);
      } else {
        setEnablePricingClassifications(false);
      }
    };

    checkEnablePricingClassifications();
  }, []);

  // Prepare async hook
  const classificationsData = useAsync({
    deferFn: enablePricingClassifications
      ? getPricingClassifications
      : getClassifications,
  });

  // Run only once
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (enablePricingClassifications !== null && !hasRunRef.current) {
      hasRunRef.current = true;
      classificationsData.run();
    }
  }, [enablePricingClassifications, classificationsData]);

  // Dispatch only when the async call succeeds
  useEffect(() => {
    if (classificationsData.status === 'fulfilled') {
      dispatch(
        setClassificationsAction({
          ...classificationsData.data,
          isPending: false,
        })
      );
    }
  }, [
    classificationsData,
    classificationsData.data,
    classificationsData.status,
    dispatch,
  ]);

  return null;
};
